(function() {
    'use strict';

    angular.module('szallodak-room-package', ['ui.router', 'ngAnimate', 'daterangepicker', 'summernote', 'dropzonelight'])
})();
